module.exports = __webpack_public_path__ + "static/media/phoneBottom.38ff45f8.png";